import React from "react"
import { useNavigate } from "react-router-dom"
import { useRegisterForm } from "../../hooks/auth/useRegisterForm"

export default function RegisterForm({ onSuccess = () => {} }) {
  const navigate = useNavigate()
  const {
    email,
    setEmail,
    password,
    setPassword,
    company,
    setCompany,
    err,
    loading,
    submit,
  } = useRegisterForm(onSuccess)

  return (
    <form
      onSubmit={submit}
      className="bg-white rounded-xl shadow p-6 space-y-4 max-w-md mx-auto"
    >
      <h3 className="text-2xl font-bold">Crear cuenta de Comercio</h3>
      {err && <p className="text-red-600">{err}</p>}

      <input
        className="w-full border rounded p-2"
        type="text"
        placeholder="Nombre del Comercio"
        value={company}
        onChange={(e) => setCompany(e.target.value)}
        required
      />

      <input
        className="w-full border rounded p-2"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        className="w-full border rounded p-2"
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <button
        disabled={loading}
        className="w-full bg-black text-white rounded p-2"
      >
        {loading ? "Creando..." : "Crear cuenta"}
      </button>

      {/* Botones adicionales con responsive */}
      <div className="flex flex-col sm:flex-row justify-between mt-4 space-y-2 sm:space-y-0">
        <button
          type="button"
          onClick={() => navigate("/login")}
          className="text-blue-600 hover:underline text-left"
        >
          ¿Ya tienes cuenta? Entrar
        </button>
        <button
          type="button"
          onClick={() => navigate("/forgot-password")}
          className="text-blue-600 hover:underline text-right"
        >
          Olvidé mi contraseña
        </button>
      </div>
    </form>
  )
}
